import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchTrustPilotLinkAction = createDataModuleActions(
    'FETCH_TRUST_PILOT_LINK',
);
export const fetchTrustPilotLink = fetchTrustPilotLinkAction.dataRequest;
export const fetchTrustPilotLinkSuccess = fetchTrustPilotLinkAction.dataSuccess;
export const fetchTrustPilotLinkError = fetchTrustPilotLinkAction.dataError;
export const fetchTrustPilotLinkReset = fetchTrustPilotLinkAction.dataReset;
